<template>
    <!-- 在父級 -->
    <a-dropdown
            overlayClassName="item-dropdown"
            :placement="placement"
            :getPopupContainer="
                        triggerNode => {
                        return triggerNode.parentNode || document.body;
                        }
                ">
        <a
                :class="disBlock ? 'display-block' : ''"
                @click="e => e.preventDefault()"
        >
            <slot></slot>
        </a>
        <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item
                    v-for="item in optionList"
                    :key="item.type"
            >
                {{item.title}}
            </a-menu-item>
        </a-menu>
    </a-dropdown>
</template>

<script>
    export default {
        props: {
            placement: {
                type: String,
                default: "bottomRight"
            },
            /*currentIdx: {
              type: Number,
              required: true
            },*/
            optionList: {
                default: () => [],
                type: Array,
            },
            disBlock: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            //點擊事件
            handleMenuClick(value) {
                this.$emit('onClick', value.key)
            }
        },
    };
</script>

<style lang="less" scoped>
    .ant-dropdown-link {
        font-size: 12px;
    }
</style>
